import { LearnFragment } from '@/graphql/fragments/learn';
import { gql } from '@apollo/client';

export const MUTATION_COMPLETE_LESSON = gql`
  mutation completeLesson($idLesson: String!, $idModule: String!, $idLearn: ID!) {
    createLearnItem(data: { idModule: $idModule, idLesson: $idLesson, learn: $idLearn }) {
      data {
        id
        attributes {
          learn {
            data {
              attributes {
                ...LearnFragment
              }
            }
          }
        }
      }
    }
  }
  ${LearnFragment}
`;

export const MUTATION_CREATE_LEARN = gql`
  mutation createLearn($idUser: ID!, $idCourse: ID!) {
    createLearn(data: { users_permissions_user: $idUser, course: $idCourse }) {
      data {
        id
        attributes {
          ...LearnFragment
        }
      }
    }
  }
  ${LearnFragment}
`;

export const MUTATION_COMPLETE_LEARN = gql`
  mutation completeLearn($idLearn: ID!) {
    updateLearn(id: $idLearn, data: { completed: true }) {
      data {
        id
        attributes {
          ...LearnFragment
        }
      }
    }
  }
  ${LearnFragment}
`;

export const MUTATION_CREATE_COURSE_FEEDBACK = gql`
  mutation createCourseFeedback($data: CourseFeedbackInput!) {
    createCourseFeedback(data: $data) {
      data {
        id
      }
    }
  }
`;
